import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAddKeyframe: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="add-keyframe, rhombus">
      <path
        d="M14.1209 3.87135C12.9493 2.69978 11.0498 2.69978 9.87823 3.87135L3.87087 9.87868C2.6993 11.0503 2.69929 12.9497 3.87086 14.1213L9.87822 20.1287C11.0498 21.3003 12.9493 21.3003 14.1209 20.1287L20.1282 14.1213C21.2998 12.9498 21.2998 11.0503 20.1282 9.87869L14.1209 3.87135Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V15M9 12H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconAddKeyframe;
